define('lib/multivariate-testing/test-configs/in-product-purchase-test',['require','exports','module','web-urls','./BaseTestConfig','../allocation-strategies/random','../check-strategies/user-settings','../save-strategies/user-settings','api-access','shared-g2m-logic'],function (require, exports, module) {
    var webUrls = require('web-urls');
    var BaseTestConfig = require('./BaseTestConfig');
    var allocationStrategy = require('../allocation-strategies/random');
    var checkStrategy = require('../check-strategies/user-settings');
    var saveStrategy = require('../save-strategies/user-settings');
    var commerceApi = require('api-access').commerce;
    var Products = require('shared-g2m-logic').Products;

    module.exports = new BaseTestConfig({
        id: 'inProductPurchaseTest',

        variations: [{id: 'control'}, {id: 'variation-a'}],

        checkEligibility: function (testId) {
            var checkingEligibility = $.Deferred();

            if (webUrls.get(testId) === 'true') {
                commerceApi.getProducts()
                    .then(function (productsResp) {
                        var products = new Products(productsResp);
                        var isTrial = !!products.findExpiringTrial();

                        if (isTrial) {
                            checkingEligibility.resolve();
                        } else {
                            checkingEligibility.reject('User is not in a trial.');
                        }
                    })
                    .fail(function () {
                        checkingEligibility.reject('Could not retrieve product data.');
                    });
            } else {
                checkingEligibility.reject('Test not active in web-urls config.');
            }

            return checkingEligibility.promise();
        },

        allocate: allocationStrategy,

        saveVariation: saveStrategy,

        checkVariation: checkStrategy
    });
});

